import { format } from "date-fns";
import { useEffect, useState } from "react";
import {
  ManualCreditReviewTimelineItem,
  ManualCreditReviewTimelineResponseItem
} from "./interface";
import classNames from "classnames";
import { useParams } from "react-router";
import { LoanApplicationService } from "src/services/LoanApplication";
import { convertUTCtoIST } from "src/shared/utils/DateUtil";

const mapWorkflowItem = (
  data: Array<ManualCreditReviewTimelineResponseItem>
) => {
  return data.map((timelineItem) => {
    return {
      title: timelineItem?.action,
      date: timelineItem.createdAt,
      updatedBy: timelineItem.actionBy,
      comments: timelineItem.comments,
      assignedUser: timelineItem.assignedUser,
      assignedUsername: timelineItem.assignedUsername,
      additionalParams: timelineItem.additionalParams,
      remarks: timelineItem?.remarks || ""
    } as ManualCreditReviewTimelineItem;
  });
};

export default function Timeline({
  token,
  isOpen,
  workflowInstanceID,
  sourceEntityID,
  whiteLabelStyle
}: {
  token: string;
  isOpen: boolean;
  workflowInstanceID: string;
  sourceEntityID: string;
  whiteLabelStyle: any;
}) {
  const [timelines, setTimelines] = useState<
    Array<ManualCreditReviewTimelineItem>
  >([]);

  const { loanID } = useParams();

  async function getTimelineData() {
    const params = {
      token: token,
      pageName: "Timeline",
      payload: {
        dashboardType: "lender",
        graphQLAction: "GetWorkflowHistory",
        workflowInstanceID: workflowInstanceID,
        sourceEntityID: sourceEntityID || "",
        loanApplicationID: loanID
      }
    };

    const response = await LoanApplicationService.fetchGraphqlData(params);

    if (response.status) {
      setTimelines(
        mapWorkflowItem((response?.data as any)?.["workflowInstanceHistory"]) ||
          []
      );
    }
  }

  useEffect(() => {
    if (isOpen) {
      getTimelineData();
    }
  }, [isOpen]);

  return (
    <div>
      {timelines?.map((info, index) => (
        <div key={index}>
          <div className="relative">
            {timelines?.length - 1 !== index && (
              <span className="absolute top-[30px] left-4 h-full w-0.5 bg-gray-200" />
            )}

            <div className="relative flex mb-4">
              <div className="pt-3">
                <span className="flex items-center justify-center h-8 w-8 bg-white rounded-md border shadow">
                  <span
                    className={classNames(
                      "block h-4 w-4 rounded-full  border-4",
                      whiteLabelStyle?.theme?.color?.bg || "bg-[#3290FE]",
                      whiteLabelStyle?.theme?.color?.borderDark ||
                        "border-[#1982FF] "
                    )}
                  />
                </span>
              </div>

              <div className="pt-4 ml-6">
                <div className=" text-[#344054] mb-1.5 font-semibold">
                  {info?.title}
                </div>
                <div className="text-[#475467] text-xs font-normal mb-1.5">
                  {convertUTCtoIST(info?.date, true)}
                </div>
                {info?.updatedBy && (
                  <div className="mb-1.5 text-[#475467] text-sm font-normal">
                    Updated by: <span className="">{info?.updatedBy}</span>
                  </div>
                )}
                {info.assignedUser && (
                  <div className="text-xs">
                    <span className="text-[#373737] font-medium">
                      Assigned User:
                    </span>{" "}
                    <span className="text-[#475467] font-normal">
                      {!info.assignedUsername || info.assignedUsername == ""
                        ? info.assignedUser
                        : info.assignedUsername +
                          " (" +
                          info.assignedUser +
                          ")"}
                    </span>
                  </div>
                )}
                {info?.comments && (
                  <div className="text-xs">
                    <span className="text-[#373737] font-medium">Comment:</span>{" "}
                    <span className="text-[#475467] font-normal">
                      {info?.comments}
                    </span>
                  </div>
                )}
                {info?.remarks && (
                  <div className="text-xs">
                    <span className="text-[#373737] font-medium">Remarks:</span>{" "}
                    <span className="text-[#475467] font-normal">
                      {info?.remarks}
                    </span>
                  </div>
                )}
                {info?.additionalParams?.riskRating && (
                  <div className="text-xs">
                    <span className="text-[#373737] font-medium">
                      Risk Rating:
                    </span>{" "}
                    <span className="text-[#475467] font-normal capitalize">
                      {info?.additionalParams?.riskRating}
                    </span>
                  </div>
                )}
                {info?.additionalParams?.rejectionReason?.length > 0 && (
                  <div className="text-xs">
                    <span className="text-[#373737] font-medium">
                      Rejection Reason:
                    </span>{" "}
                    <span className="text-[#475467] font-normal capitalize">
                      {info?.additionalParams?.rejectionReason?.map(
                        (reason: string, index: number) => (
                          <span key={index} className="mr-1">
                            {reason}
                            {info?.additionalParams?.rejectionReason?.length -
                              1 !==
                              index && ","}
                          </span>
                        )
                      )}
                    </span>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
